import { Component, inject, Input, OnInit } from '@angular/core';
import { ASSET_CONSTANTS } from '../../../shared/constants/asset-constants';
import { DatePipe } from '@angular/common';
import {
  INotificationContent,
  NotificationsService,
} from '../../../core/services/notifications.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mb-notifications',
  imports: [DatePipe],
  templateUrl: './mb-notifications.component.html',
})
export class MbNotificationsComponent implements OnInit {
  private notificationsService = inject(NotificationsService);
  protected readonly ASSET_CONSTANTS = ASSET_CONSTANTS;
  notifications: INotificationContent[] = [];
  private router = inject(Router);

  openNotification(notification: INotificationContent) {
    this.markAsRead(notification);
    this.router.navigate(['/dashboard/cases/', notification.caseId]);
    this.closeDrawer();
  }

  markAsRead(notification: INotificationContent) {
    this.notificationsService.markAsRead(notification.id).subscribe(() => {
      // The service now handles updating the notifications automatically
      // No need to manually update the local array
    });
  }

  ngOnInit(): void {
    this.notificationsService
      .getNotificationsObservable()
      .subscribe((notifications) => {
        this.notifications = notifications;
      });

    // Load initial notifications
    this.notificationsService.getNotifications().subscribe();
  }

  @Input() handleClose!: () => void;

  closeDrawer() {
    this.handleClose();
  }
}
